import { useDashboardStore } from '@/stores/dashboard'
import { maSessionStorage } from '@/lib/storage'
import { maLogger } from './logger'

// Errors related to dynamic import failures
const importErrors = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
]

// Check if the provided error is related to dynamic imports
function isImportError(message = '') {
  return importErrors.some(errorMessage =>
    message.toLowerCase().includes(errorMessage),
  )
}

// Check if sufficient time has passed since the last chunk refresh
function shouldRefresh(lastChunkRefresh = 0) {
  const timeSinceLastRefresh = new Date().getTime() - lastChunkRefresh
  return timeSinceLastRefresh >= 60000 // 1 minute
}

/**
 * Handles routing errors specifically for dynamic import issues.
 * Redirects the user to the intended route if a certain time has passed since the last refresh,
 *
 * @param {Error} error - The error object caught during routing.
 * @param {RouteLocationNormalized} to - The target location the router is navigating to.
 */
export async function MaRouterErrorHandler(error, to) {
  if (isImportError(error?.message) && shouldRefresh(maSessionStorage.lastChunkRefresh)) {
    maSessionStorage.lastChunkRefresh = new Date().getTime()
    window.location.href = to.path
  }
}

export function MaVueErrorHandler(error) {
  const dashboardStore = useDashboardStore()

  if (isImportError(error?.message) && shouldRefresh(maSessionStorage.lastChunkRefresh)) {
    maSessionStorage.lastChunkRefresh = new Date().getTime()
    dashboardStore.openNewReleaseWarning()
  }
  maLogger.error('Vue Error:', error)
}
